import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Notiflix from "notiflix";

export const DownloadLeadsXlsx = ({ list = [] }) => {
	const headers = [
		{ label: 'First Name', key: 'fld_first_name' },
		{ label: 'Last Name', key: 'fld_last_name' },
		{ label: 'Country', key: 'fld_country' },
		{ label: 'Mobile Number', key: 'fld_mobile_number' },
		{ label: 'Email Address', key: 'fld_email_address' },
		{ label: 'City of Interest', key: 'fld_city_of_interest' },
		{ label: 'Budget', key: 'budget' },
		{ label: 'Property Type', key: 'fld_property_type' },
		{ label: 'Status', key: 'fld_leads_status' },
		{ label: 'Timeline', key: 'fld_timeline_to_invest' },
		{ label: 'Remarks', key: 'fld_remarks' }
	]

	const downloadXLSX = async () => {
		try {
			Notiflix.Loading.dots();

			const data = list || [];

			if (!data.length) {
				Notiflix.Loading.remove();
				// toast.warning("No data available to download");
				return;
			}
			const formattedData = data.map(row => {
				const newRow = {};

				headers.forEach(col => {
					const fieldKey = col.key || col.value;
					newRow[col.label] = row[fieldKey];

				});

				return newRow;
			});

			const worksheet = XLSX.utils.json_to_sheet(formattedData);

			// Optional: Auto column width
			const columnWidths = Object.keys(data[0]).map(key => ({
				wch: Math.max(
					key.length,
					...data.map(row => (row[key] ? row[key].toString().length : 0))
				)
			}));

			worksheet["!cols"] = columnWidths;

			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, "Leads Reports");

			const excelBuffer = XLSX.write(workbook, {
				bookType: "xlsx",
				type: "array",
			});

			const fileBlob = new Blob([excelBuffer], {
				type: "application/octet-stream",
			});

			saveAs(fileBlob, "Leads-Reports.xlsx");

			Notiflix.Loading.remove();

		} catch (err) {
			console.error(err);
			Notiflix.Loading.remove();
		}
	};
	return (
		<>
			<button
				type="button"
				className="visitor-btn"
				onClick={() => downloadXLSX()}
			>
				Download xlsx
			</button>
		</>
	)
}
